<template>
  <property-compare
    v-if="!reportLoading"
    is-sample-view
    :comparable-addresses="sample.comparable_addresses"
    :subject="sample.subject"
    :report="sample"
  >
    <template #primay-button>
      <q-btn no-caps unelevated color="primary" :to="{ name: 'Subscribe to Property Reports' }">
        7-Day Free Trial
      </q-btn>
    </template>
  </property-compare>
</template>
<script lang="ts">
import { type PropType } from 'vue'
import PropertyCompare from '@/components/PropertyReports/PropertyCompare.vue'
import type { PropertyReportSubscriptionAttributes } from 'common'
import { usePropertyReportStore } from '@/stores/propertyreport'

export default {
  name: 'PropertyReportsSample',
  components: { PropertyCompare },
  props: {
    sample: {
      required: true,
      type: Object as PropType<PropertyReportSubscriptionAttributes>
    }
  },
  data() {
    return {
      reportLoading: false,
      report: null as PropertyReportSubscriptionAttributes | null
    }
  },
  watch: {
    sample() {
      this.loadReport()
    }
  },
  methods: {
    loadReport() {
      usePropertyReportStore().cleanReportData()
      this.reportLoading = true
      this.$nextTick(() => {
        this.reportLoading = false
      })
    }
  }
}
</script>
